module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","urlAlreadyExist":"This URL already exists. Please use another one."}


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientPreferences/locales/fr.json
// module id = 1458
// module chunks = 0